import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const fetchUserInfo = createAsyncThunk(
  "user/fetch-user-info",
  async () => {
    return await userService.fetchUserInfo();
  }
);

export const addDailyCredits = createAsyncThunk(
  "user/add-daily-credits",
  async () => {
    return await userService.addDailyCredits();
  }
);

export const changeUsername = createAsyncThunk(
  "user/set-username",
  async (requestData) => {
    return await userService.setUsername(requestData);
  }
);

export const deleteAccount = createAsyncThunk(
  "user/delete-account",
  async () => {
    return await userService.deleteAccount();
  }
);

export const getReferralUsers = createAsyncThunk(
  "user/referral-users",
  async () => {
    return await userService.getReferralUsers();
  }
);
